(function () {

  function bindDrawer() {
    document.querySelectorAll('[data-pf-deal-apply]').forEach(function (button) {
      button.addEventListener('click', function (e) {
        if (typeof openPFDrawer === 'function') {
          e.preventDefault();
          openPFDrawer('quick-apply');
        }
      });
    });

    document.querySelectorAll('[data-pf-card-apply]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-pf-deal-apply]')) return;
        if (typeof openPFDrawer === 'function') {
          e.preventDefault();
          openPFDrawer('quick-apply');
        }
      });

      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (typeof openPFDrawer === 'function') openPFDrawer('deal-apply');
        }
      });
    });
  }

  function debounce(fn, delay) {
    var timer;
    return function () { clearTimeout(timer); timer = setTimeout(fn, delay); };
  }

  function initPFTopDealsCarousels() {
    document.querySelectorAll('.pf-top-deals__carousel, .pf-top-phones__grid').forEach(function (carousel) {

      if (carousel.dataset.pfCarouselReady === 'true') return;
      carousel.dataset.pfCarouselReady = 'true';
      console.log('[PF] carousel found, scrollWidth:', carousel.scrollWidth, 'clientWidth:', carousel.clientWidth);

      var dots = document.createElement('div');
      dots.className = 'pf-carousel-dots';
      carousel.insertAdjacentElement('afterend', dots);

      function getPages() { return Math.ceil(carousel.scrollWidth / carousel.clientWidth); }

      function buildDots() {
        var pages = getPages();
        dots.innerHTML = '';
        if (pages <= 1) { dots.style.display = 'none'; return; }
        dots.style.display = 'flex';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pf-carousel-dot';
          dot.dataset.index = i;
          dot.addEventListener('click', function () {
            var allDots = dots.querySelectorAll('.pf-carousel-dot');
            carousel.scrollTo({
              left: (carousel.scrollWidth - carousel.clientWidth) * (Number(this.dataset.index) / (allDots.length - 1)),
              behavior: 'smooth'
            });
          });
          dots.appendChild(dot);
        }
        updateDots();
      }

      function updateDots() {
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        var allDots = dots.querySelectorAll('.pf-carousel-dot');
        var index = maxScroll > 0 ? Math.round((carousel.scrollLeft / maxScroll) * (allDots.length - 1)) : 0;
        allDots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      }

      var isDown = false, startX = 0, scrollLeft = 0, moved = false;

      carousel.addEventListener('mousedown', function (e) {
        isDown = true; moved = false;
        carousel.classList.add('is-dragging');
        startX = e.pageX; scrollLeft = carousel.scrollLeft;
      });
      carousel.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var walk = (e.pageX - startX) * 1.3;
        if (Math.abs(walk) > 5) moved = true;
        carousel.scrollLeft = scrollLeft - walk;
      });
      carousel.addEventListener('mouseup', function () { isDown = false; carousel.classList.remove('is-dragging'); });
      carousel.addEventListener('mouseleave', function () { isDown = false; carousel.classList.remove('is-dragging'); });
      carousel.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      carousel.addEventListener('scroll', updateDots);
      window.addEventListener('resize', debounce(buildDots, 150));
      buildDots();
    });
  }

  function init() {
    bindDrawer();
    initPFTopDealsCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();